import {
  LEAD_CAPTURE_DROPDOWN,
  LEAD_CAPTURE_DROPDOWN_SUCCESS,
  LEAD_CAPTURE_DROPDOWN_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const leadCaptureDropdownReducer = (state = initialState, action) => {
  switch (action.type) {
    case LEAD_CAPTURE_DROPDOWN:
      return { ...state, loading: true };
    case LEAD_CAPTURE_DROPDOWN_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case LEAD_CAPTURE_DROPDOWN_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default leadCaptureDropdownReducer;
